import { Drawer } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { MODAL_SIZES } from 'config/modaSettings';

import { CommentsDrawerContent } from './Content';
import { DeleteActivityModal } from './DeleteActivityModal';
import { CommentsDrawerHeader } from './Header';
import { CommentComponentsCommonProps } from './types';

const CommentsDrawer: React.FC<CommentComponentsCommonProps> = ({
  commentsStore,
}) => {
  React.useEffect(() => {
    if (commentsStore.drawerState.opened) {
      commentsStore.fetchActivities();
    }
  }, [commentsStore, commentsStore.drawerState.opened]);

  return (
    <Drawer
      open={commentsStore.drawerState.opened}
      onClose={commentsStore.drawerState.close}
      width={MODAL_SIZES.m}
      title={<CommentsDrawerHeader commentsStore={commentsStore} />}
    >
      <CommentsDrawerContent commentsStore={commentsStore} />
      <DeleteActivityModal commentsStore={commentsStore} />
    </Drawer>
  );
};

export default observer(CommentsDrawer);
